import { z } from "zod";

export const skillProficiencyEnum = z.enum([
  "expert",
  "advanced",
  "intermediate",
  "familiar",
]);

export const draftSkillItemSchema = z.object({
  name: z.string().max(100),
  proficiency: skillProficiencyEnum.optional(),
});

export const skillItemSchema = z.object({
  name: z.string().trim().min(1, "Skill name is required").max(100),
  proficiency: skillProficiencyEnum.optional(),
});

export const draftSkillGroupSchema = z.object({
  id: z.string().default(() => crypto.randomUUID()),
  categoryName: z.string().max(100), // empty allowed in draft
  skills: z.array(draftSkillItemSchema).max(30).default([]),
});

export const skillGroupSchema = z.object({
  id: z.string().default(() => crypto.randomUUID()),
  categoryName: z.string().trim().min(1, "Category name is required").max(100),
  skills: z.array(skillItemSchema).max(30).default([]),
});

import { getSectionDisplayOptionsSchema } from "../display-options";

export const skillsDisplayOptionsSchema = getSectionDisplayOptionsSchema("skills");
export type SkillsDisplayOptions = z.infer<typeof skillsDisplayOptionsSchema>;

export const draftSkillsContentSchema = z.object({
  heading: z.string().max(100).default("Skills & Methodologies"),
  displayStyle: z.enum(["categorized_cards", "tag_cloud", "list"]).default("categorized_cards"),
  groups: z.array(draftSkillGroupSchema).max(15).default([]),
  displayOptions: skillsDisplayOptionsSchema.optional(),
});



export const skillsContentSchema = z.object({
  heading: z.string().trim().min(1).max(100).default("Skills & Methodologies"),
  displayStyle: z.enum(["categorized_cards", "tag_cloud", "list"]).default("categorized_cards"),
  groups: z.array(skillGroupSchema).max(15).default([]),
  displayOptions: skillsDisplayOptionsSchema.optional(),
});

export type SkillProficiency = z.infer<typeof skillProficiencyEnum>;
export type SkillItem = z.infer<typeof skillItemSchema>;
export type DraftSkillItem = z.infer<typeof draftSkillItemSchema>;
export type SkillGroup = z.infer<typeof skillGroupSchema>;
export type DraftSkillGroup = z.infer<typeof draftSkillGroupSchema>;
export type SkillsContent = z.infer<typeof skillsContentSchema>;
export type DraftSkillsContent = z.infer<typeof draftSkillsContentSchema>;
